import React from 'react';
import ShareButtons from '../ShareButtons';
import {
  ArticleText,
  ArticleSectionStyle,
  ArticleContainer,
} from './styles/ArticlesStyle';
import ArticleSection from './ArticleSection';
import styled from 'styled-components';
import GetYourGuideWidget from '../Affiliates/GetYourGuideWidget';
import { getYourGuideWidgets } from '../Affiliates/utils/getYourGuideConfig';
import { ContentSection } from '../../content/types';

// Affiliate banner styled component
const AffiliateBanner = styled.div`
  display: flex;
  justify-content: center;
  margin: 2rem auto;
  padding: 0 15px;
  max-width: 1400px;

  img {
    max-width: 100%;
    height: auto;
    border-radius: ${({ theme }) => theme.borderRadius.medium};
    box-shadow: ${({ theme }) => theme.shadows.small};
    transition: transform 0.2s ease-in-out;

    &:hover {
      transform: scale(1.02);
    }
  }

  @media (max-width: 768px) {
    margin: 1.5rem auto;

    img {
      max-width: 400px;
      width: 100%;
    }
  }
`;

const DestinationAffiliateHeading = styled.h2`
  text-align: center;
  font-size: 1.8rem;
  margin: 0px auto 20px;
  color: ${({ theme }) => theme.colors.text.primary};
  font-weight: 600;
`;

interface ArticleContentProps {
  introduction: string;
  sections: ContentSection[];
  shareUrl: string;
  shareTitle: string;
  destinationName?: string;
}

const ArticleContent: React.FC<ArticleContentProps> = ({
  introduction,
  sections,
  shareUrl,
  shareTitle,
  destinationName,
}) => {
  return (
    <ArticleContainer>
      {/* <ShareButtons url={shareUrl} title={shareTitle} /> */}

      <ArticleSectionStyle>
        <ArticleText dangerouslySetInnerHTML={{ __html: introduction }} />
      </ArticleSectionStyle>

      {sections.map((section, index) => (
        <React.Fragment key={index}>
          <ArticleSectionStyle>
            <ArticleSection
              title={section.title}
              content={section.content}
              type={section.type}
              imageUrl={section.imageUrl}
              description={section.description}
              isBold={section.isBold}
              sectionLink={section.sectionLink}
              is12GoBanner={section.is12GoBanner}
            />
          </ArticleSectionStyle>

          {section.displayRentalAffiliate && (
            <AffiliateBanner>
              <a
                href="https://www.tkqlhce.com/click-101081442-15594382"
                target="_top"
              >
                <img
                  src="https://www.awltovhc.com/image-101081442-15594382"
                  width="400"
                  height="209"
                  alt="Affiliate Banner"
                  style={{ border: 0 }}
                />
              </a>
            </AffiliateBanner>
          )}

          {section.tourIds && (
            <>
              <DestinationAffiliateHeading>
                אטרקציות נבחרות להזמנה דרך GetYourGuide
              </DestinationAffiliateHeading>
              <div
                style={{
                  justifyContent: 'center',
                  margin: '20px 0',
                }}
              >
                <GetYourGuideWidget tourIds={section.tourIds} />
              </div>
            </>
          )}
        </React.Fragment>
      ))}
    </ArticleContainer>
  );
};

export default ArticleContent;
